module.exports = __webpack_public_path__ + "img/color_block_8.b358d0e7.svg";